import React from "react";
import styled from "styled-components/macro";

import { Icon } from "@chanzuckerberg/eds";

import getReflectionTypeIcon, {
  ReflectionType,
} from "../getReflectionTypeIcon";

import { theme } from "ui/theme";

const $IllustrationContainer = styled.div`
  display: inline-block;
  position: relative;
  width: 1.75rem;
  height: 1.75rem;
`;

const $NotificationBadge = styled.div`
  background-color: ${theme.ColorMint500};
  border-radius: 50%;
  height: 1rem;
  width: 1rem;
  position: absolute;
  right: -0.25rem;
  top: -0.25rem;
`;

export type StudentNavIllustrationProps = {
  hasNotifications?: boolean;
  type: ReflectionType;
};

export default function StudentNavIllustration({
  hasNotifications,
  type,
  ...props
}: StudentNavIllustrationProps) {
  return (
    <$IllustrationContainer>
      <Icon
        {...props}
        name={getReflectionTypeIcon(type)}
        purpose="decorative"
        size="1.75rem"
        color={theme.ColorSpace500}
      />
      {hasNotifications && (
        <$NotificationBadge aria-label="Unread messages" role="status" />
      )}
    </$IllustrationContainer>
  );
}
